export default {
  nameIsRequired: 'El nombre es requerido',
  emailIsRequired: 'El email es requerido',
  passwordIsRequired: 'La contraseña es requerida',
  emailOrPhoneAreRequired: 'Ingresa un email o teléfono',
  onlyNumbers: 'Sólo se permiten números en este campo',
  passwordMin8: 'La contraseña debe tener minimo 8 carácteres',
  habeasData: 'Debes aceptar las políticas de tratamiento de datos',
  validEmail: 'Ingresa un email válido',
  validPhone: 'Ingresa un teléfono válido',
  codeIsRequired: 'Ingresa el código enviado',
  newPasswordIsRequired: 'La nueva contraseña es requerida',
  confirmNewPassword: 'Debes confirmar tu nueva contraseña',
  passwordsDontMatch: 'Las contraseñas no coinciden',
  fillCorrectlyFormFields: 'Llena correctamente todos los datos del formulario'
}
